module.exports = __webpack_public_path__ + "static/media/single-neutral-profile-picture.ccff8851.svg";